// extracted by mini-css-extract-plugin
export var closeButton = "_p5-2";
export var closeButtonIcon = "_p5-3";
export var lightboxContent = "_p5-1";
export var lightboxOverlay = "_p5-0";